import {FC, useEffect} from 'react';
import {Box} from '@mui/material';
import AuctionHeader from '../components/AuctionHeader';
import AuctionItemsList from '../components/AuctionItemsList';
import {liveAuction} from './liveAuction.styles';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getAuctionCategories, getAuctionCategoriesSelector} from '@/store/organization-auction';
import {userAPI} from '@/core/api';

const LiveAuction: FC = () => {
	const dispatch = useAppDispatch();

	const categories = useAppSelector(getAuctionCategoriesSelector);

	useEffect(() => {
		const getCategoryData = async () => {
			await dispatch(getAuctionCategories(userAPI)).unwrap();
		};

		getCategoryData();
	}, []);

	return (
		<Box sx={liveAuction.wrapper}>
			<AuctionHeader />
			<AuctionItemsList categories={categories ?? []} auctionType="Live" key="Live" />
		</Box>
	);
};

export default LiveAuction;
